import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setValue } from '../redux/mostQueueAlertsReducer';
import { setValue as setDateFilter } from '../redux/dateFilterReducer';
import { setValue as setUser } from '../redux/userReducer';
import logo from '../assets/images/logo-white.svg';

import { RootState } from '../redux/store';
import DownloadUserManual from '../pages/UserManual/DownloadUserManual';
import { setDemoProduct } from '../redux/demoProductReducer';
import { EProductType, setActiveProduct } from '../redux/activeProductReducer';
import { unassignToken } from '../redux/userReducer';
import { useEffect, useState } from 'react';
import getRoleId from '../web_api/methods/account/getRoleId';
import { DEMO_ACCOUNTS } from '../web_api/constants';

export default function SidebarFooter() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const userName = useSelector((state: RootState) => state.user.user_name);
  const [userRole, setUserRole] = useState(0);
  const existingRole = useSelector((state: RootState) => state.user.role);
  const isCloud = process.env.REACT_APP_IS_CLOUD === 'true';
  const hasNotifications = useSelector((state: RootState) => state.user.hasNotifications);

  const loadInitialData = async () => {
    if (existingRole && existingRole !== 0) return setUserRole(existingRole);
    const roleId = await getRoleId();
    setUserRole(roleId);
    dispatch(setUser({ ...user, role: roleId }));
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const logout = () => {
    localStorage.clear();

    dispatch(
      setValue({
        list: [],
      })
    );
    dispatch(
      setDateFilter({
        from: new Date().toISOString(),
        to: new Date().toISOString(),
      })
    );
    dispatch(unassignToken());

    navigate(process.env.REACT_APP_HOMEPAGE + '/login');
    // window.location.reload();
  };
  const resetProducts = () => {
    dispatch(
      setDemoProduct({
        demoProduct: EProductType.NONE,
      })
    );
    dispatch(
      setActiveProduct({
        activeProduct: EProductType.NONE,
      })
    );
    navigate(process.env.REACT_APP_HOMEPAGE + '/home');
    window.location.reload();
  };
  return (
    <>
      <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
        {/* <DownloadUserManual /> */}
      </div>
      <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6 ' id='kt_app_sidebar_footer'>
        {!isCloud && (
          <div
            onClick={() => {
              dispatch(setUser({ ...user, hasNotifications: hasNotifications === "true" ? "false" : "true" }));
            }}
            className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-30px w-100 my-2'
          >
            <i className='bi bi-gear me-1' />
            <span className='btn-label'>Turn {hasNotifications === "true" ? 'Off' : 'On'} Notifications</span>
          </div>
        )}
        {userRole === 5 && (
          <div
            onClick={() => {
              navigate(process.env.REACT_APP_HOMEPAGE + '/reports');
            }}
            className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-30px w-100 mb-2'
          >
            <i className='bi bi-graph-up-arrow me-1' />
            <span className='btn-label'>Reports</span>
          </div>
        )}
        
        {DEMO_ACCOUNTS.includes(userName) && (
          <div
            onClick={resetProducts}
            className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
            title='Hub'
          >
            <span className='btn-label'>Back to Hub</span>
          </div>
        )}

        <span className='d-flex overflow-hidden text-muted flex-center my-3'>
          <span className='btn-label'>{userName}</span>
        </span>
        <div
          onClick={logout}
          className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
          title='Log out'
        >
          <span className='btn-label'>Log out</span>
        </div>
        {/* <div className='d-flex flex-center mt-5'>
          <img
            alt='Logo'
            src={logo}
            className='w-50'
          />
        </div> */}
      </div>
    </>
  );
}
